export const DEFAULT_AVATAR_SRC = '/default-avatar.svg';

export const getProfileImageSrc = (baseUrl, folder, image) => {
  if (!image) {
    return DEFAULT_AVATAR_SRC;
  }

  return `${baseUrl}/uploads/${folder}/${image}`;
};
